import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/salesData';
import { BonusMockup } from './BonusMockup';
const coverColors = ['#A96B7B',
// rosa empolvado
'#8A9A7B',
// verde salvia apagado
'#C9A66B',
// dorado antiguo
'#7E8CA0',
// azul grisáceo
'#B57F62',
// terracota suave
'#6E5A66' // ciruela apagado
];
export function BonusSection() {
  return <section className="py-20 px-4 bg-surface-light" data-id="element-23" data-mp="1ao7ah51dmncy">
      <div className="max-w-6xl mx-auto" data-id="element-24" data-mp="1aop4rw4hari8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-25" data-mp="15pm932ae1xmx">
          <h2 className="text-4xl md:text-6xl font-black mb-6 text-primary tracking-tight" data-id="element-26" data-mp="r0gejrmhwvld">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-27" data-mp="my39z6jhj3q6">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-flex items-center gap-2 bg-accent text-white px-8 py-4 rounded-full font-bold text-xl shadow-lg" data-id="element-28" data-mp="2er64sr929hfg">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-29" data-mp="2ogpou08ifhbw">
          {bonuses.map((bonus, index) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.1
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-30" data-mp="1qu0jphiigolt" data-mpi={index}>
              <BonusMockup number={bonus.id} icon={bonus.icon} coverColor={coverColors[index % coverColors.length]} data-id="element-31" data-mp="1h3f1nn0n754l" />

              <div className="mt-6 mb-4" data-id="element-32" data-mp="1c6esv4cero9s">
                <span className="inline-block bg-surface-accent text-primary px-5 py-1.5 rounded-full text-sm font-bold tracking-wide" data-id="element-33" data-mp="1q4lhruzdqdxb">
                  GRATIS
                </span>
              </div>

              <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-3 leading-tight" data-id="element-34" data-mp="yc4dveq7r8gx">
                {bonus.icon} Bonus {bonus.id} — {bonus.title}
              </h3>

              <p className="text-gray-500 text-base leading-relaxed" data-id="element-35" data-mp="174z8zflyvnsz">
                {bonus.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}